function tryDate(day, month, year) {
	if (month < 1 || month > 12 || day < 1 || day > 31) return null
	const date = new Date(Date.UTC(year, month - 1, day))
	if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null
	return date
}

export function parseFolderDate(path) {
	const name = path.replace(/\/$/, "").split("/").pop() ?? ""

	// dd-MM-yyyy
	const dashDmy = name.match(/^(\d{2})-(\d{2})-(\d{4})$/)
	if (dashDmy) return tryDate(+dashDmy[1], +dashDmy[2], +dashDmy[3])

	// yyyy-MM-dd
	const dashYmd = name.match(/^(\d{4})-(\d{2})-(\d{2})$/)
	if (dashYmd) return tryDate(+dashYmd[3], +dashYmd[2], +dashYmd[1])

	// 8-digit compact: try ddMMyyyy first, then yyyyMMdd
	const compact = name.match(/^(\d{8})$/)
	if (compact) {
		const d = compact[1]
		return tryDate(+d.slice(0, 2), +d.slice(2, 4), +d.slice(4, 8))
			?? tryDate(+d.slice(6, 8), +d.slice(4, 6), +d.slice(0, 4))
	}

	return null
}

export function sortFolders(commonPrefixes) {
	return commonPrefixes
		.map(path => ({ path, date: parseFolderDate(path) }))
		.sort((a, b) => {
			if (a.date && b.date) return b.date - a.date || a.path.localeCompare(b.path)
			if (a.date) return -1
			if (b.date) return 1
			return a.path.localeCompare(b.path)
		})
		.map(({ path }) => path)
}

export function sortFiles(objectSummaries) {
	return objectSummaries
		.filter(item => !!item.fileName)
		.map(item => {
			const parsed = item.lastModifiedAt ? new Date(item.lastModifiedAt).getTime() : Number.NEGATIVE_INFINITY
			return { item, ms: Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY }
		})
		.sort((a, b) => b.ms - a.ms || a.item.key.localeCompare(b.item.key))
		.map(({ item }) => item)
}
